import {css} from "@emotion/css";
import React, {useEffect, useRef, useState} from "react";
import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import {useNavigate} from "react-router-dom";
import {RouteInfo} from "../../../route/RouteHelper";
import {RaikoSimpleInputOutlined} from "@moeindal/base-raiko-panel-components";
import {FormControl} from "@mui/material";
import RaikoMaterialOutlinedPasswordInput
    from "../../../raikoComponents/raikoInputs/RaikoMaterialOutlinedPasswordInput";
import Recaptcha from "react-google-recaptcha";
import {LoginService} from "../../../connection-services/login/LoginService";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import {
    getLoginPassword,
    getLoginUserName,
    setLoginPassword,
    setLoginUserName
} from "../../../service/localStorage/LocalStorageService";
import {Helmet} from "react-helmet";
import {RaikoButtonPrimary, showErrorMessage, RaikoCheckbox} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";


export default function SignInEnterPhoneNumber() {
    const service = new LoginService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    const [loadingButtonState, setLoadingButtonState] = useState(false);

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberUser, setRememberUser] = useState(false);

    const [error, setError] = useState("");

    const navigate = useNavigate()

    useEffect(() => {
        const _username = getLoginUserName()
        const _password = getLoginPassword()

        if (_username && _username.length > 0 && _password && _password.length > 0) {
            setUsername(_username)
            setPassword(_password)
            setRememberUser(true)
        }

    }, []);

    function validateEnterInfo() {
        if (checkFields()) {
            setLoadingButtonState(true)
            sendSubmitCode("")
        }
    }

    function checkFields() {
        if (username.length > 0 && password.length > 0) {
            return true
        } else {
            snackbar.showWarningMessage("لطفا نام کاربری و رمز عبور خود را به درستی وارد نمایید.")
            return false
        }
    }

    function goToConfirmCodePage(time) {
        navigate(RouteInfo.SignInEnterSubmitCode.globalUrl, {state: {username, password}, replace: true})
    }

    function sendSubmitCode(key) {
        setLoadingButtonState(true)
        service.sendVerificationCode(username, password, key)
            .then(response => {

                if (response.status === "SENT") {
                    checkForSaveLoginInfo()
                    goToConfirmCodePage(response.time)
                    snackbar.showSuccessMessage("کد تایید با موفقیت ارسال شد.")
                } else {
                    snackbar.showServerErrorMessage(response, "خطا، امکان ارسال پیامک در این لحظه وجود ندارد!")
                }

            }).catch(reason => {

            if (new ServerErrorHandler(reason).getStatusCode() === 403) {
                snackbar.showErrorMessage("خطا در اعتبارسنجی کاربر، لطفـا مجددا تلاش نمایید.")
                setRecaptchaGeneratedKey(null)
            } else
                showErrorMessage(detectServerErrorMessage(reason))

        }).finally(_ => {
            setLoadingButtonState(false)
        })
    }

    function checkForSaveLoginInfo() {
        if (rememberUser) {
            setLoginUserName(username)
            setLoginPassword(password)
        }
    }

    const reCaptchaRef = useRef(undefined);
    const [recaptchaGeneratedKey, setRecaptchaGeneratedKey] = useState(null);

    const handleGenerateRecaptcha = () => {
        return new Promise(async (resolve, reject) => {

            if (recaptchaGeneratedKey) {
                setRecaptchaGeneratedKey(null)
                window.grecaptcha.reset();
            }

            let newVar = await reCaptchaRef.current.executeAsync();

            resolve(newVar)

        })
    }


    return (
        <>
            <Helmet>
                <title>{RouteInfo.SignInEnterPhoneNumber.name}</title>
            </Helmet>

            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>ورود به سامانه</span>
                </div>
                <form className={"signInContentContainer"}>
                    <p className={"signInTitle"}>سامانه ی مدیریت صمن</p>
                    <span className={"subTitle"}>برای ورود به سامانه نام کاربری و رمز عبور خود را وارد نمایید</span>
                    <RaikoSimpleInputOutlined
                        labelText={"نام کاربری"}
                        setValue={setUsername}
                        value={username}
                    />

                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedPasswordInput
                            labelText="رمز عبور"
                            placeHolder="رمز عبور خود را وارد کنید"
                            spellCheck={false}
                            value={password}
                            onChange={e => {
                                setPassword(e.target.value)
                            }}

                            onKeyUp={e => {

                                if (e.key === 'Enter') {
                                    validateEnterInfo()
                                }
                            }}

                        />
                    </FormControl>
                    <RaikoCheckbox
                        label={"من را به خاطر بسپار"}
                        checked={rememberUser}
                        setChecked={setRememberUser}
                    />

                    {/*<Recaptcha
                        ref={reCaptchaRef}
                        className={'g-recaptcha'}
                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                        render={"explicit"}
                        size={"invisible"}
                        onChange={setRecaptchaGeneratedKey}
                        hl={"fa"}
                    />*/}

                    <RaikoButtonPrimary
                        label={"تایید"}
                        onClick={validateEnterInfo}
                        className={css`width: 100%`}
                        loading={loadingButtonState}
                    />

                    <span className={"forgetPassword"}
                          onClick={_ => {
                              navigate(RouteInfo.SignInForgetPassword.globalUrl, {replace: true})
                          }}>فراموشی رمز عبور</span>
                </form>
            </div>
        </>

    )
}